<div
  class="flex flex-col items-end gap-3"
  data-testid="notifications-stack"
>
  @for (notification of data.notifications(); track `${notification.id}-${notification.status}`) {
    <flx-notification
      [notification]="notification"
      [paused]="paused()"
      [attr.data-status]="notification.status"
      [attr.data-type]="notification.type"
      (closed)="data.dismiss(notification.id)"
      (read)="markAsRead(notification.id)"
      class="block w-[420px] cursor-pointer"
      data-testid="notification"
    />
  }
</div>
